import { apiMotivoConsultaCreateRegistro, apiMotivoConsultaGetResgistros } from "../settings/apiConfig";
import { createContext, useContext, useState } from "react";
import { fnPrevent, fnPreventBlur } from "../settings/preventConfig";
import { getFormMotivoConsulta, getModelMotivoConsulta } from "../models/MotivoConsultaModel";

import { fnHandleChangeText } from "../settings/handleConfig";
import { useCatalogo } from "./CatalogoContext";
import { useLayout } from "./LayoutContext";
import { useLogin } from "./LoginContext";
import { useRequest } from "./RequestContext";

export const MotivoConsultaContext = createContext();

export function MotivoConsultaProvider(props) {
    const { handleOpenAlert } = useLayout();
    const { usuarioSesion } = useLogin();
    const { Get, Post } = useRequest();
    const { entCatalogos } = useCatalogo();

    const [listaMotivoConsulta, setListaMotivoConsulta] = useState([]);
    const [motivoConsultaSeleccionada, setMotivoConsultaSeleccionada] = useState(getModelMotivoConsulta());
    const [modalOpenFormMotivoConsulta, setModalOpenFormMotivoConsulta] = useState(false);
    const [modalOpenEliminarMotivoConsulta, setModalOpenEliminarMotivoConsulta] = useState(false);
    const [formMotivoConsulta, setFormMotivoConsulta] = useState(getFormMotivoConsulta());

    const handleOpenFormMotivoConsulta = (value) => {
        setModalOpenFormMotivoConsulta(value);
    };

    const handleOpenEliminarMotivoConsulta = (value) => {
        setModalOpenEliminarMotivoConsulta(value);
    };

    const handleChangeMotivoConsultaSeleccionada = (value) => {
        setMotivoConsultaSeleccionada(value);
    };

    const handleChangeFormMotivoConsulta = fnHandleChangeText(formMotivoConsulta, setFormMotivoConsulta);

    const handleClickNuevaMotivoConsulta = () => {
        const motivoConsulta = getModelMotivoConsulta();
        setMotivoConsultaSeleccionada(motivoConsulta);
        fnFillFormMotivoConsulta(motivoConsulta);
        setModalOpenFormMotivoConsulta(true);
    };

    const handleClickEditarMotivoConsulta = () => {
        if (motivoConsultaSeleccionada.iIdMotivoConsulta === 0) {
            handleOpenAlert("Seleccione un motivo de consulta para editar");
            return;
        }
        fnFillFormMotivoConsulta(motivoConsultaSeleccionada);
        setModalOpenFormMotivoConsulta(true);
    };

    const handleClickEliminarMotivoConsulta = () => {
        if (motivoConsultaSeleccionada.iIdMotivoConsulta === 0) {
            handleOpenAlert("Seleccione un motivo de consulta para eliminar");
            return;
        }

        setModalOpenEliminarMotivoConsulta(true);
    };

    const handleClickRefrescarDatos = () => {
        fnObtenerMotivoConsulta();
    };

    const handleSubmitFormMotivoConsulta = (e) => {
        fnPrevent(e);

        const { txtNombre, txtNombreEng } = formMotivoConsulta;
        const form = {
            ...formMotivoConsulta,
            txtNombre: {
                ...txtNombre,
                error: txtNombre.value === "",
            },
            txtNombreEng: {
                ...txtNombreEng,
                error: txtNombreEng.value === "",
            },
        };

        setFormMotivoConsulta(form);
        if (
            Object.values(form)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        const entMotivoConsulta = {
            iIdMotivoConsulta: motivoConsultaSeleccionada.iIdMotivoConsulta,
            sNombre: txtNombre.value,
            sNombreIngles: txtNombreEng.value,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            bActivo: true,
            bBaja: false,
        };

        fnGuardarMotivoConsulta(entMotivoConsulta);
    };

    const handleSubmitEliminarMotivoConsulta = () => {
        const entMotivoConsulta = {
            iIdMotivoConsulta: motivoConsultaSeleccionada.iIdMotivoConsulta,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            bActivo: false,
            bBaja: true,
        };
        fnEliminarMotivoConsulta(entMotivoConsulta);
    };

    const fnFillFormMotivoConsulta = (motivoConsulta) => {
        const { txtNombre, txtNombreEng } = getFormMotivoConsulta();
        setFormMotivoConsulta({
            ...formMotivoConsulta,
            txtNombre: {
                ...txtNombre,
                value: !motivoConsulta.sNombre ? "" : motivoConsulta.sNombre,
            },
            txtNombreEng: {
                ...txtNombreEng,
                value: !motivoConsulta.sNombreIngles ? "" : motivoConsulta.sNombreIngles,
            },
        });
    };

    const fnObtenerMotivoConsulta = async (piIdMotivoConsulta = null) => {
        const payload = {
            loader: "Consultando motivos de consulta...",
            url: apiMotivoConsultaGetResgistros + "?piIdMotivoConsulta=" + piIdMotivoConsulta,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaMotivoConsulta(response.Result);
        }
    };

    const fnGuardarMotivoConsulta = async (entMotivoConsulta) => {
        const payload = {
            loader: "Guardando motivo de consulta...",
            url: apiMotivoConsultaCreateRegistro,
            body: entMotivoConsulta,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenFormMotivoConsulta(false);
            setMotivoConsultaSeleccionada(entMotivoConsulta);
            await fnObtenerMotivoConsulta();
        }
        fnPreventBlur();
    };

    const fnEliminarMotivoConsulta = async (entMotivoConsulta) => {
        const payload = {
            loader: "Eliminando motivo consulta...",
            url: apiMotivoConsultaCreateRegistro,
            body: entMotivoConsulta,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenEliminarMotivoConsulta(false);
            setMotivoConsultaSeleccionada(getModelMotivoConsulta());
            await fnObtenerMotivoConsulta();
        }
        fnPreventBlur();
    };

    return (
        <MotivoConsultaContext.Provider
            value={{
                listaMotivoConsulta,
                motivoConsultaSeleccionada,
                modalOpenFormMotivoConsulta,
                modalOpenEliminarMotivoConsulta,
                formMotivoConsulta,
                handleOpenFormMotivoConsulta,
                handleOpenEliminarMotivoConsulta,
                handleChangeMotivoConsultaSeleccionada,
                handleChangeFormMotivoConsulta,
                handleClickNuevaMotivoConsulta,
                handleClickEditarMotivoConsulta,
                handleClickEliminarMotivoConsulta,
                handleClickRefrescarDatos,
                handleSubmitFormMotivoConsulta,
                handleSubmitEliminarMotivoConsulta
            }}
        >
            {props.children}
        </MotivoConsultaContext.Provider>
    );
}

export function useMotivoConsulta() {
    return useContext(MotivoConsultaContext);
}
